export default __webpack_public_path__ + "static/media/imageTum8.4a2fad94.jpg";